/**
 * SVG for everyone
 */

 svg4everybody();
